import { apiRequest } from "@/lib/api/client";
import type {
  CreateProjectBody,
  ProjectDto,
  UpdateProjectBody,
} from "@/lib/api/types";

export async function listProjects(): Promise<ProjectDto[]> {
  return apiRequest<ProjectDto[]>("/projects");
}

export async function getProject(id: string): Promise<ProjectDto> {
  return apiRequest<ProjectDto>(`/projects/${encodeURIComponent(id)}`);
}

export async function createProject(body: CreateProjectBody): Promise<ProjectDto> {
  return apiRequest<ProjectDto>("/projects", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function updateProject(
  id: string,
  body: UpdateProjectBody,
): Promise<ProjectDto> {
  return apiRequest<ProjectDto>(`/projects/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export async function deleteProject(id: string): Promise<void> {
  await apiRequest<void>(`/projects/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
